"use client";

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useRouter } from "next/navigation";
import { CircleChevronLeft } from "lucide-react";
import "./BackButton.css";

interface BackButtonProps {
  defaultRoute?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ defaultRoute = "/" }) => {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push(defaultRoute);
    }
  };

  if (!mounted) return null;

  return createPortal(
    <div className="back-button-portal">
      <button onClick={handleBack} className="back-button-container">
        <CircleChevronLeft size={32} className="setting-back-botton" />
      </button>
    </div>,
    document.body
  );
};

export default BackButton;
